import React, {useContext, useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import moment from "moment";
import LoaderCircle from "../../../loader/LoaderCircle";
import LastCreatedIcon from "../../../icons/LastCreatedIcon";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import AppContext from "../../../../context/AppContext";;

const LastCreated = () => {
	const { setEvent } = useContext(AppContext);
	const [ list, setList ] = useState([]);
	const [ loading, setLoading ] = useState(true);
	const location = useLocation();

	const refresh = () => {
		const controller = new StoreController();
		controller._callback = handleRefresh;
		controller.getLastCreated(10);
	}
	const handleRefresh = (list, error, status) => {
		setLoading(false);

		switch (status) {
			case 200:
				setList(list);
				break;
			default:
				setEvent({
					type: "error",
					text: "Une erreur s'est produite lors du chargement des derniers clients créés"
				});
				break;
		}
	}

	useEffect(() => {
		refresh();
	}, []);
	useEffect(() => {
		if (location !== undefined && location.state !== undefined && location.state === "closeFrontSheet")
			refresh();
	}, [location]);

    return (
        <div className="block lastCreated">
			<div className={"containerTitle"}>
				<LastCreatedIcon />
				<p>Derniers clients créés</p>
			</div>
			<div className={"list"}>
				{
					loading
						? <LoaderCircle display="loader loadingDashboard" strokeWidth="8" stroke="#006D3E" />
						: (
							list.length > 0
								? list.map((store, index) => (
									<Link key={index} to={ "clients/" + store.id + "/informations" }>
										<div key={index} className={"elmt"}>
											<p className={"text"}>{ store.fullname() }</p>
											<p className={"since"}>Il y a { moment(store.created_at).fromNow(true) }</p>
										</div>
									</Link>
								))
								: <div className={"elmt empty"}><p className={"text empty"}>Aucune création</p></div>
						)

				}
			</div>
		</div>
    )
}

export default LastCreated;
